import axios from "axios"
import { IsAuthorized } from "src/authentication/IsAuthorized"
import { getJWT } from "src/helper/localStore/getJWT"

class SupplierBillingServices{
    async checkBilling(itemId:number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/supplier-billing/item_id/${itemId}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getInvoiceFromSupplierBilling(supplier_billing_id : number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/supplier-billing/invoice/${supplier_billing_id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const supplierBillingServices = new SupplierBillingServices()